/** MSWを起動 */
export const enableMocking = async (mock: boolean) => {
  if (!mock) return;

  const { worker } = await import('~/api/mock/browser');

  return worker.start({
    /**
     * MSWのリクエストハンドラーに定義されていないリクエストに対しての警告を無効化する
     * @see https://mswjs.io/docs/api/setup-worker/start#onunhandledrequest
     */
    onUnhandledRequest: 'bypass',
  });
};
